
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiForceCurrentTrue as ObiForceCurrentTrueElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-force-current-true.js';
 
 
 

 
 export const ObiForceCurrentTrue = createComponent({
   react: React,
   tagName: 'obi-force-current-true',
   elementClass: ObiForceCurrentTrueElement,
   events: {
     
   }
  });
 
 